export const RsaPublicKey =
  'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDAjQDj9Iwjyb7oqzr1/XoTrH9qBvnaFqH8JKvVtgIxPm4KRCeV5dqifzbE/IE525NQPiv6H1nBEn9Khr7iKb3Kdt/t2YiozwDYvfWGw19n3cUtWFTC0sWaouhEeW1lSV7f1fGtslZN4pORJdiHyTUsdGV5UmNs7nyKBumM9yyeawIDAQAB';
